import { Alert } from '@simplywallst/ui-core';
import type { PortfolioLinkingSDKError } from '../../../LinkingProviders/error/PortfolioLinkingSDKError';

type Props = {
  error: PortfolioLinkingSDKError;
};

export const LinkingSDKError = ({ error }: Props) => {
  return <Alert styleType="negative">{error.message}</Alert>;
};
